var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfusionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #2a4265;\n      }\n\n      .cls-2 {\n        stroke: #2a4265;\n        stroke-width: 37px;\n      }\n\n      .cls-2, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        fill: url(#New_Gradient_Swatch_1-2);\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: url(#New_Gradient_Swatch_1);\n        stroke-width: 27px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 24.79,
    y1: 547.33,
    x2: 1048.88,
    y2: 547.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c81515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc1111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    "data-name": "New Gradient Swatch 1",
    x1: 369.06,
    y1: 670.53,
    x2: 655.54,
    y2: 670.53,
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 536.83,
    cy: 547.33,
    r: 451
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 536.83,
    cy: 547.33,
    r: 498.55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Transfusion"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m734.46,290.88h-192.42c-.89-7.17-3.44-13.86-7.39-19.25-5.65-7.7-13.79-12.12-22.35-12.12s-16.7,4.42-22.35,12.12c-3.95,5.39-6.5,12.08-7.39,19.25h-126.71l-32.75-34.01c-5.59-5.8-14.82-5.98-20.63-.39-5.8,5.59-5.98,14.82-.39,20.63l37.06,38.48c2.75,2.86,6.54,4.47,10.51,4.47h132.56v11.58h-64.14c-27.02,0-48.93,21.91-48.93,48.93l-.06,281.52c0,71.15,48.44,122.01,110.3,127.41v25.18s0,.01,0,.01c0,0,23.16,10.66,26.51,12.23,5.95,2.81,7.37,2.65,13.31-.21,4.29-2.07,26.04-12.02,26.04-12.02,0,0,0,0,0-.01v-25.19c61.91-5.59,110.3-58.59,110.3-127.4l-.02-33.01-.16-248.51c0-27.02-21.91-48.93-48.93-48.93h-64.02v-11.58h177.47v548.38c0,8.06,6.53,14.59,14.59,14.59s14.59-6.53,14.59-14.59V305.47c0-8.06-6.53-14.59-14.59-14.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m369.06,662.08c0,71.15,48.44,122.01,110.3,127.41v25.18s0,.01,0,.01c0,0,23.16,10.66,26.51,12.23,5.95,2.81,7.37,2.65,13.31-.21,4.29-2.07,26.04-12.02,26.04-12.02,0,0,0,0,0-.01v-25.19c61.91-5.59,110.3-58.59,110.3-127.4l-.02-33.01-.08-116.94h-286.35l-.03,149.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m512.3,280.91c3.09,0,6.56,4.06,8.01,9.96h-16.02c1.45-5.9,4.92-9.96,8.01-9.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 503.6,
    y: 320.06,
    width: 17.4,
    height: 11.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m619.55,672.26c.07,48.6-26.92,69.1-55.03,64.88,15.39-7.13,24.49-24.19,25.11-61.42.35-20.98,1.11-67.27.55-146.77l30.13-.04-.76,143.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m606.43,364.89c8.64,0,15.67,7.03,15.67,15.7l.09,131.55h-219.83v-23.85h41.24c1.57,0,2.85-1.28,2.85-2.85v-10.45c0-1.57-1.28-2.85-2.85-2.85h-41.23v-21.85h41.23c1.57,0,2.85-1.28,2.85-2.85v-10.45c0-1.57-1.28-2.85-2.85-2.85h-41.22v-21.38h41.22c1.57,0,2.85-1.28,2.85-2.85v-10.45c0-1.57-1.28-2.85-2.85-2.85h-41.21v-16.02c0-8.64,7.04-15.67,15.68-15.67h188.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfusionIcon);
export default __webpack_public_path__ + "static/media/Transfusion-Icon.ab6147fd734ea580e223cba39352e81d.svg";
export { ForwardRef as ReactComponent };